<template lang="pug">

  .lesson-block.main-block
    .lesson-block__content(v-if="!isEditLocal")
      p.lesson-block__title.main-block__title(v-if="content.header")
        | {{content.header}}

      .lesson-block__row.-files-row-
        File(
          v-for="file in content.files" :key="file.id"
          :file="file"
          icon="image"
          :canDelete="false"
        )

    template(v-else)
      .lesson-block__content
        Input.lesson-block__edit(
          v-model="contentLocal.header"
          title="Заголовок")


        .lesson-block__row.-files-row-
          UploadFiles(
            @getFiles="getFiles"
            :fileExt="fileExt"
            :fileMime="fileMime"
            :multiple="true"
            :hugeFiles="true"
            buttonText="Загрузить файлы"
          )

          File(
            v-for="file in contentLocal.files" :key="file.id"
            :file="file"
            icon="image"
            @deleteFile="addFileToDelete(file)"
          )

        .lesson-block__buttons
          Button.-xs-(@click="saveBlock" :isLoading="uploadingFiles") Сохранить
          ButtonCancel.-xs-.hover__link(@click="cancel") Отмена

    ControlsArrow.lesson__controls(
      :firstBlock="isFirstBlock"
      :lastBlock="isLastBlock"
      v-if="$permissionsUpdate"
      @moveUp="moveUp"
      @moveDown="moveDown"
    )

    OptionsList.course-lesson__options(
      v-if="optionsFields.length"
      :optionsFields="optionsFields"
    )

</template>

<script>
import _ from 'lodash';
import File from '@/components/File/File';
import UploadFiles from '@/components/Form/UploadFiles';

import blockPermissionMixin from '@/views/Courses/Lesson/components/block.permission.mixin';

export default {
  components: {
    File,
    UploadFiles
  },
  mixins: [blockPermissionMixin],
  props: {
    permissions: {},
    isEdit: {
      default: false,
      type: Boolean
    },
    content: {},
    arrows: {
      default: true,
      type: Boolean
    },
    isFirstBlock: {
      default: false,
      type: Boolean
    },
    isLastBlock: {
      default: false,
      type: Boolean
    },
    isLoading: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      contentLocal: {},
      filesToDelete: [],
      isEditLocal: false,
      uploadingFiles: false,
      fileExt: ['.odt', '.docx'],
      fileMime: [
        'image/*',
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/plain',
        'text/csv'
      ]
    };
  },
  computed: {
    optionsFields() {
      const arr = [];
      if (this.$permissionsUpdate) {
        arr.push({
          text: 'Редактировать',
          func: this.openBlockEdit,
          icon: 'edit'
        });
      }

      if (this.$permissionsCreate) {
        arr.push({
          text: 'Дублировать',
          func: this.duplicateBlock,
          icon: 'copy'
        });
      }

      if (this.$permissionsDelete) {
        arr.push({
          text: 'Удалить',
          func: this.deleteBlock,
          icon: 'delete',
          iconWidth: '10px',
          confirm: true,
          confirmTitle: 'Вы уверены, что хотите удалить этот блок?',
          confirmDescription: 'Блок будет удален навсегда',
          confirmApplyText: 'Удалить',
          confirmCancelText: 'Отменить',
          red: true
        });
      }

      return arr;
    }
  },
  watch: {
    isEditDefault() {
      this.isEditLocal = this.isEdit;
    },
    content() {
      this.setData();
    }
  },
  mounted() {
    this.setData();

    if (this.contentLocal.forceEdit) {
      this.isEditLocal = true;
      delete this.contentLocal.forceEdit;
    }
  },
  methods: {
    setData() {
      this.contentLocal = _.cloneDeep(this.content);
    },
    openBlockEdit() {
      this.isEditLocal = true;
    },
    deleteBlock() {
      this.$emit('deleteBlock');
    },
    async saveBlock() {
      if (this.filesToDelete.length > 0) {
        this.deleteFiles();
        // После удаления файлов вызовется saveBlock и этот if заигнорится
        return;
      }

      setTimeout(() => {
        this.isEditLocal = false;
      }, 1000);

      this.$emit('saveBlock', this.contentLocal);
    },
    deleteFiles() {
      const files = this.filesToDelete.map(f => {
        return { id: f.id };
      });
      this.$store.dispatch('coursesLesson/deleteFiles', { files });
      this.filesToDelete = [];
      this.saveBlock();
    },
    cancel() {
      this.isEditLocal = false;
      this.setData();
    },
    duplicateBlock() {
      this.$emit('duplicateBlock');
    },
    moveUp() {
      this.$emit('moveUp');
    },
    moveDown() {
      this.$emit('moveDown');
    },
    async getFiles({ formData }) {
      this.uploadingFiles = true;
      const files = await this.$store.dispatch('ajax/uploadFile', { formData });
      this.uploadingFiles = false;
      if (files) {
        files.forEach(f => {
          this.contentLocal.files.push(f);
        });
      }
    },
    async addFileToDelete(file) {
      this.filesToDelete.push(file);

      const fileIdx = this.contentLocal.files.findIndex(f => f.id === file.id);

      if (fileIdx !== -1) {
        this.contentLocal.files.splice(fileIdx, 1);
        this.contentLocal.files = [...this.contentLocal.files];
      }
    }
  }
};
</script>
